import { removeFromLocalStorage } from "./localStorageUtils";
import { removeFromSessionStorage } from "./sessionStorageUtils";
import { LocalStorageKey, SessionStorageKey } from "./storageKeys";
import { WEBSITE_UNPUBLISHED_ERROR_MESSAGE } from "./constants";

export const clearStorageOnError = () => {
  [
    LocalStorageKey.TABLE_DATA,
    LocalStorageKey.SCAN_TO_ORDER_INFO,
    LocalStorageKey.BOOKED_SERVICE_CART,
  ].forEach((key: LocalStorageKey) => removeFromLocalStorage(key));
  [
    SessionStorageKey.GIFT_CARD_INFO,
    SessionStorageKey.DELIVERY_TRACKING_URL,
    SessionStorageKey.CAN_ACCESS_CONFIRMATION,
    SessionStorageKey.RECEIPT_ID,
  ].forEach((key: SessionStorageKey) => removeFromSessionStorage(key));
};

export const isWebsiteUnpublishedError = (data: any): boolean => {
  if (
    data?.errors?.[0]?.error &&
    data.errors[0].error.toLowerCase().includes(WEBSITE_UNPUBLISHED_ERROR_MESSAGE)
  ) {
    return true;
  }

  return false;
};
